import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Scroll to bottom on initial load
    this.scrollToBottom()

    // Set up MutationObserver to watch for new messages
    this.observer = new MutationObserver((mutations) => {
      let force = false
      
      // Check if any added node is a user message (justify-end)
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.classList.contains('justify-end')) {
            force = true
            break
          }
        }
        if (force) break
      }
      
      this.scrollToBottom(force)
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: false
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom(force = false) {
    // With flex-col-reverse or justify-end, the content is already at the bottom.
    // But if there is overflow, we still need to scroll.
    // However, we need to be careful not to force scroll if the user is reading history.
    
    // Simple check: if we are near the bottom, or if it's the initial load, scroll.
    const threshold = 150
    const isNearBottom = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight < threshold
    
    if (force || isNearBottom || !this.hasScrolled) {
      this.element.scrollTop = this.element.scrollHeight
      this.hasScrolled = true
    }
  }
}
